import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { AdmissionDataMock, AdmissionProps, AdmissionResMock } from '../types/admission.type'

export const useAdmissionOrder = (arg?: AdmissionProps) => {
  const patientId = arg?.patientId
  const id = arg?.id
  const query = arg?.query
  const limit = arg?.limit
  const page = arg?.page
  const sortDir = arg?.sortDir || 'asc'
  const telemetry = arg?.telemetry || ''
  const status = arg?.status || ''

  const { data: admissionOrders, isLoading: admissionOrdersIsLoading } = useQuery({
    // enabled: !!patientId,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<AdmissionResMock<AdmissionDataMock[]>>('/admission_orders', {
        params: {
          ...(sortDir && { sortDir }),
          ...(query && { query }),
          ...(page && { 'page[number]': page }),
          ...(limit && { 'page[size]': limit }),
          ...(telemetry && { telemetry }),
          ...(status && { status })
        }
      })
      return data
    },

    queryKey: ['admission_orders', { limit, page, patientId, query, telemetry, status }]
  })

  const { mutateAsync: createAdmissionOrder } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post(`/patients/${patientId}/admission_orders`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admission_orders', { patientId }] })
      queryClient.invalidateQueries({ queryKey: ['encounters'] })
    }
  })

  const { mutateAsync: updateAdmissionOrder } = useMutation({
    mutationFn: async ({ formVal, id }: { formVal: any; id: string }) => {
      await AXIOS_INSTANCE.patch(`admission_orders/${id}`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admission_orders'] })
      queryClient.invalidateQueries({ queryKey: ['bedRequest'] })
    }
  })

  const { mutateAsync: deleteAdmissionOrder } = useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await AXIOS_INSTANCE.delete(`admission_orders/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admission_orders'] })
      queryClient.invalidateQueries({ queryKey: ['bedRequest'] })
    }
  })
  const { data: singleAdmission, isLoading: singleAdmissionIsLoading } = useQuery({
    enabled: !!id,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<AdmissionResMock<AdmissionDataMock>>(`admission_orders/${id}`)
      return data.data
    },
    queryKey: ['admissions', { id }]
  })

  return {
    admissionOrders: admissionOrders?.data,
    admissionOrdersIsLoading,
    createAdmissionOrder,
    deleteAdmissionOrder,
    includedData: admissionOrders?.included,
    singleAdmission,
    singleAdmissionIsLoading,
    updateAdmissionOrder
  }
}
